module.exports = __webpack_public_path__ + "static/media/behance.972fc9d7.svg";